import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { TimerIcon } from 'lucide-react';
const COUNTDOWN_DURATION = 15 * 60;
const COUNTDOWN_STORAGE_KEY = 'urgency_bar_15_min_end_time';
function getTimeLeft() {
  const savedEndTime = Number(localStorage.getItem(COUNTDOWN_STORAGE_KEY));
  if (savedEndTime) {
    return Math.max(0, Math.floor((savedEndTime - Date.now()) / 1000));
  }
  const endTime = Date.now() + COUNTDOWN_DURATION * 1000;
  localStorage.setItem(COUNTDOWN_STORAGE_KEY, String(endTime));
  return COUNTDOWN_DURATION;
}
export function UrgencyOfferSection() {
  const [timeLeft, setTimeLeft] = useState(getTimeLeft);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black py-12 md:py-16 px-4 border-y-4 border-gray-900 relative overflow-hidden pt-[25px] pb-[25px] mt-[0px] mb-[0px]" data-id="element-446" data-mp="2j0m9uruhioqs">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-full bg-red-900/20 blur-[100px] pointer-events-none rounded-full" data-id="element-447" data-mp="2ntfcna6e7n08"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-448" data-mp="2wqps77q8tyay">
        <div className="text-center mb-10" data-id="element-449" data-mp="31rdghln3811h">
          <div className="inline-flex items-center gap-2 bg-red-600/20 text-red-500 px-6 py-2 rounded-full font-black text-sm md:text-base uppercase tracking-widest border border-red-500/50 mb-6" data-id="element-450" data-mp="31rn6h984u876">
            Oferta por tiempo limitado
          </div>

          <h2 className="md:text-5xl font-black text-white mb-6 text-[20px]" data-id="element-451" data-mp="1cbw1mvmkmfr4">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h2>
        </div>

        {/* Neon Countdown Timer */}
        <div className="flex justify-center mb-10" data-id="element-452" data-mp="zcmxusb4so61">
          <div className="bg-gray-900 border-2 border-red-600 rounded-3xl p-6 md:p-10 animate-neon-red text-center min-w-[300px] md:min-w-[400px]" data-id="element-453" data-mp="zdy2svgbc1yq">
            <div className="flex items-center justify-center gap-3 mb-4 text-red-500" data-id="element-454" data-mp="19auax02aum2r">
              <TimerIcon className="w-8 h-8" data-id="element-455" data-mp="1nac6pze0izlm" />
              <span className="text-xl font-bold uppercase tracking-widest" data-id="element-456" data-mp="1n913c0ohbtv1">
                Tiempo Restante
              </span>
            </div>
            <div className="text-6xl md:text-8xl font-black text-red-500 tracking-wider font-mono animate-pulse-fast drop-shadow-[0_0_15px_rgba(220,38,38,0.8)]" data-id="element-457" data-mp="1i9em7g5j5tgy">
              {pad(hours)}:{pad(minutes)}:{pad(seconds)}
            </div>
          </div>
        </div>

        {/* Scarcity Bar */}
        <div className="bg-gray-900/80 rounded-2xl p-6 md:p-8 border border-gray-800 pt-[20px] pb-[20px] mt-[20px] mb-[20px]" data-id="element-458" data-mp="25yh3gmw95kax">
          <div className="flex justify-between items-end mb-3" data-id="element-459" data-mp="2kn0q89p901ok">
            <div className="flex items-center gap-2 text-red-500 font-bold text-lg md:text-xl uppercase" data-id="element-460" data-mp="2klpla6k2gnvv">
              ¡SOLO QUEDAN 10 CUPOS!
            </div>
            <span className="text-gray-400 font-medium" data-id="element-461" data-mp="2bm2hje3v75zn">75% Lleno</span>
          </div>
          <div className="w-full h-6 bg-gray-800 rounded-full overflow-hidden border border-gray-700" data-id="element-462" data-mp="2gkvxdd6mj92z">
            <motion.div initial={{
            width: '0%'
          }} animate={{
            width: '65%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gradient-to-r from-red-700 to-red-500 relative" data-id="element-463" data-mp="21vzqvkk7u44h">
              <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.2)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.2)_50%,rgba(255,255,255,0.2)_75%,transparent_75%,transparent)] bg-[length:20px_20px] animate-[slide_1s_linear_infinite]" data-id="element-464" data-mp="1ixn58zc4b1s0"></div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}